var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 19.125C25.8688 17.6524 26.2543 16.0248 26.25 14.375V13.75C26.1063 11.1446 25.0065 8.6837 23.1614 6.83857C21.3163 4.99345 18.8554 3.89374 16.25 3.75H15.625C13.9752 3.7457 12.3476 4.13117 10.875 4.875C9.11032 5.75696 7.62603 7.11281 6.5884 8.79069C5.55076 10.4686 5.00076 12.4022 5 14.375C4.9957 16.0248 5.38116 17.6524 6.125 19.125L3.75 26.25L10.875 23.875C12.3476 24.6188 13.9752 25.0043 15.625 25C17.5978 24.9992 19.5314 24.4492 21.2093 23.4116C22.8872 22.374 24.243 20.8897 25.125 19.125Z",
    stroke: "#B4D4FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/message-circle.1e26b1f3a138bb649c8772e5c274c4c5.svg";
export { ForwardRef as ReactComponent };